export const DEFAULT_CONTRACT_TEMPLATES = [
  {
    id: "online-store",
    name: "Online Store Contract",
    title: "Online Store Development, Hosting & Management Agreement",
    content: `TOORA FLEX (PTY) LTD
ONLINE STORE DEVELOPMENT, HOSTING & MANAGEMENT AGREEMENT

Agreement Date: {{AGREEMENT_DATE}}   |   Agreement Number: {{AGREEMENT_NUMBER}}

1. PARTIES

1.1. The Service Provider
Toora Flex (Pty) Ltd
Registration Number: 2026 / 036648 / 07
Registered Office & Postal Address: 367 Helen Joseph Street, Pretoria Central, Pretoria, Gauteng, 0001
Website: www.tooraflex.co.za | Email: info@tooraflex.co.za
(“Toora Flex”, “Provider”, “We”, or “Us”)

1.2. The Client
Business: {{BUSINESS_NAME}}
Client full name: {{CLIENT_FULL_NAME}}
Representative: {{CONTACT_NAME}}
Phone: {{PHONE}}
Email: {{EMAIL}}
(“Client”, “You”, or “Your”)

2. DEFINITIONS AND INTERPRETATION

“Agreement” means this contract, including its schedules. “Business Day” means any day other than a Saturday, Sunday, or public holiday in South Africa. “Client Content” means all text, images, product descriptions, logos, and data supplied by the Client. “Effective Date” means the date the Client accepts this Agreement during onboarding. “Hosting Environment” means the cloud infrastructure managed by Toora Flex. “Store” or “Website” means the one online store developed and managed under this Agreement. “Subscription Fee” means the fee for the selected package and billing period stated below for hosting, management, and platform services. “Services” means the development, hosting, management, and maintenance services described in this Agreement.

3. PROJECT DESCRIPTION AND SCOPE OF WORK

3.1. Toora Flex agrees to design, configure, deploy, host, and manage one professionally branded online store on the Toora Flex eCommerce platform in accordance with this Agreement.

3.2. Services included
• Professional online store design and branding alignment.
• Mobile-responsive theme configuration.
• Product catalogue setup and organisation for up to {{PRODUCT_LIMIT}} products.
• Secure checkout configuration in a PCI-DSS compliant environment.
• SSL security certificate installation.
• Domain registration and setup where included in the selected package.
• Reliable hosting on the Toora Flex platform.
• Basic SEO configuration, including meta titles, descriptions, and sitemap.
• Payment gateway and shipping configuration supported by the selected package.
• Business-hours technical and hosting support, routine health checks, and monthly backups.

3.3. Domain
{{DOMAIN_TERMS}}
Domain ownership remains registered in the Client’s name where registration is included and the Client provides the required registration information.

3.4. Exclusions
Custom graphic design or logo creation, services beyond the selected product limit, custom email hosting, bespoke software or external integrations, copywriting, product photography, paid advertising, and advanced SEO are excluded unless agreed in writing and may be quoted separately.

4. FEES AND PAYMENT TERMS

Selected package: {{PACKAGE_NAME}}
Package price per billing period: {{MONTHLY_FEE}}
Setup fee: {{SETUP_FEE}}
Domain total: {{DOMAIN_FEE}}
Total amount due now: {{UPFRONT_DUE}}

{{ONBOARDING_BILLING_SUMMARY}}

4.1. The selected package charge and any applicable domain charge shown in the billing summary are due upon acceptance of this Agreement and before project commencement. All paid packages, including Lite, are charged at the displayed package price. Trial onboarding has no package charge.
4.2. Package charges are for the billing period stated above. Any package setup fee is waived unless an amount is expressly shown as due on the invoice.
4.3. Payments may be made using the payment methods presented in the client portal. Fees are stated in South African Rand (ZAR), and invoices are sent electronically.
4.4. If payment is overdue by 14 days, Toora Flex may temporarily suspend hosting and services until the account is settled. A reactivation fee may apply where disclosed on the applicable invoice.
4.5. Trial: {{TRIAL_TERMS}}

5. IMPLEMENTATION, REVIEW AND ACCEPTANCE

Services commence once this Agreement is accepted, required payment is received (if applicable), and mandatory Client assets are supplied. Standard deployment is targeted within seven Business Days after commencement. On delivery, the Client has five Business Days to review the Store and provide written feedback. If no written feedback is received within that period, the Store will be considered accepted.

6. INTELLECTUAL PROPERTY AND DATA PROTECTION

6.1. Client Content, logos, product images, and trademarks remain the Client’s property.
6.2. The underlying software, platform engine, layout frameworks, and source code remain the intellectual property of Toora Flex.
6.3. Toora Flex will handle personal information in accordance with the Protection of Personal Information Act 4 of 2013 (POPIA).
6.4. The Client must keep its account email address current. While an account or service remains active, Toora Flex may email notices reasonably necessary to provide or protect the Services, including invoices and payment reminders, account and security notices, onboarding and store or system updates, planned maintenance, service interruptions, suspension or shutdown notices, and legal or contractual notices. These essential service communications are separate from optional newsletters, promotional messages, and other non-essential updates.
6.5. Optional newsletters, promotions, and non-essential updates are sent only where the Client has separately opted in. The Client may withdraw that consent at any time using the unsubscribe link in an email or the account communication settings. Unsubscribing from optional messages does not stop essential service communications while an account or service remains active.
6.6. The Client may submit an account or data deletion request through the account portal or by contacting Toora Flex. Requests are reviewed before action is taken. Toora Flex may retain information where required by law or reasonably necessary for accounting, outstanding payments, contractual obligations, dispute resolution, fraud prevention, security, or the establishment, exercise, or defence of legal claims. Closing an account does not automatically cancel amounts already due.

7. CANCELLATION AND TERMINATION

Either party may terminate this Agreement by giving 30 days’ written notice to info@tooraflex.co.za. Hosting services cease at the end of the paid billing period. A domain registered in the Client’s name may be transferred upon request, subject to settlement of outstanding invoices.

8. CLIENT ACCEPTANCE

By selecting the acceptance checkbox and submitting the onboarding request, the Client confirms that they have read, understood, and agree to this Agreement. The recorded acceptance date and onboarding request form the electronic record of acceptance. No Provider director signature is required.`,
  },
  {
    id: "website",
    name: "Website Contract",
    title: "Website Design, Development & Hosting Agreement",
    content: `TOORA FLEX (PTY) LTD
WEBSITE DESIGN, DEVELOPMENT & HOSTING AGREEMENT

Agreement Date: {{AGREEMENT_DATE}}   |   Agreement Number: {{AGREEMENT_NUMBER}}

1. PARTIES
Service Provider: Toora Flex (Pty) Ltd, Registration Number 2026 / 036648 / 07, 367 Helen Joseph Street, Pretoria Central, Pretoria, Gauteng, 0001. Website: www.tooraflex.co.za | Email: info@tooraflex.co.za.

Client: {{BUSINESS_NAME}}
Representative: {{CONTACT_NAME}}
Phone: {{PHONE}} | Email: {{EMAIL}}

2. SERVICES
Toora Flex will provide the website design, development, hosting, configuration, and support services agreed for the Client’s service request. The agreed deliverables, schedule, and exclusions must be confirmed in writing before work begins.

3. FEES AND PAYMENT
Selected service: {{PACKAGE_NAME}}
Monthly fee: {{MONTHLY_FEE}}
Setup fee: {{SETUP_FEE}}
Domain total: {{DOMAIN_FEE}}
Upfront amount due: {{UPFRONT_DUE}}

Payment is due according to the invoice and the payment terms confirmed by Toora Flex. Any recurring hosting or maintenance charges will be invoiced in advance.

4. TIMELINE AND ACCEPTANCE
The service commencement date depends on acceptance of this Agreement, receipt of required payment, and receipt of the Client materials needed to perform the work. The Client will review delivered work and provide feedback within five Business Days.

5. OWNERSHIP AND DATA
Client-provided content remains the Client’s property. Toora Flex retains ownership of its platform, software, reusable tools, and source code. Personal information will be handled in accordance with POPIA.
5.1. The Client must keep its account email address current. While an account or service remains active, Toora Flex may email notices reasonably necessary to provide or protect the Services, including invoices and payment reminders, account and security notices, onboarding and website or system updates, planned maintenance, service interruptions, suspension or shutdown notices, and legal or contractual notices. These essential service communications are separate from optional newsletters, promotional messages, and other non-essential updates.
5.2. Optional newsletters, promotions, and non-essential updates are sent only where the Client has separately opted in. The Client may withdraw that consent at any time using the unsubscribe link in an email or the account communication settings. Unsubscribing from optional messages does not stop essential service communications while an account or service remains active.
5.3. The Client may submit an account or data deletion request through the account portal or by contacting Toora Flex. Requests are reviewed before action is taken. Toora Flex may retain information where required by law or reasonably necessary for accounting, outstanding payments, contractual obligations, dispute resolution, fraud prevention, security, or the establishment, exercise, or defence of legal claims. Closing an account does not automatically cancel amounts already due.

6. CANCELLATION
Either party may terminate ongoing services by giving 30 days’ written notice to info@tooraflex.co.za. Outstanding invoices remain payable.

7. CLIENT ACCEPTANCE
By selecting the acceptance checkbox and submitting the service request, the Client confirms that they have read, understood, and agree to this Agreement. The recorded acceptance date and service request form the electronic record of acceptance.`,
  },
];

export const createContractTemplate = (index) => ({
  id: `service-${Date.now()}`,
  name: `New Service Contract ${index}`,
  title: "New Service Agreement",
  content: `TOORA FLEX (PTY) LTD
NEW SERVICE AGREEMENT

Agreement Date: {{AGREEMENT_DATE}}   |   Agreement Number: {{AGREEMENT_NUMBER}}

1. PARTIES
Client: {{BUSINESS_NAME}}
Representative: {{CONTACT_NAME}}
Phone: {{PHONE}} | Email: {{EMAIL}}

2. SERVICE DESCRIPTION
Describe the service, deliverables, and exclusions.

3. FEES AND PAYMENT TERMS
Selected service: {{PACKAGE_NAME}}
Monthly fee: {{MONTHLY_FEE}}
Setup fee: {{SETUP_FEE}}
Upfront amount due: {{UPFRONT_DUE}}

4. TIMELINE AND ACCEPTANCE
Describe the schedule, review period, and how the client accepts delivery.

5. OWNERSHIP, DATA PROTECTION, AND CANCELLATION
Describe ownership, data protection, and cancellation terms.

6. CLIENT ACCEPTANCE
By selecting the acceptance checkbox and submitting the service request, the Client confirms that they have read, understood, and agree to this Agreement.`,
});
